var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.bodyList),function(item,index){return _c('div',{key:index,staticClass:"list-box"},[_c('h1',[_vm._v(_vm._s(item.new1))]),_c('div',{staticClass:"text"},[_c('h2',[_vm._v(_vm._s(item.new2))]),_c('p',[(item.new3)?_c('span',[_vm._v("质控标准：")]):_vm._e(),_vm._v(_vm._s(item.new3))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }